import find from 'lodash/find';
export default class GroupService {
    constructor(groups) {
        this._groups = groups;
    }
    get groups() {
        return this._groups;
    }
    getGroupById(groupId) {
        return find(this._groups, (group) => group.id == groupId) || null;
    }
}
